import React from "react";
import { Box } from "@mui/material";
import GenieSkeleton from "../../../../components/core/genie-skeleton/GenieSkeleton";

function ProductTileLoad() {
  return (
    <Box
      sx={{
        display: "inline-block",
        padding: 1,
      }}
    >
      <GenieSkeleton width={"100%"} sx={{ aspectRatio: "1 / 1" }} />
      <GenieSkeleton height={24} sx={{ mt: 2 }} />
      <GenieSkeleton height={24} sx={{ mt: 1 }} />
      <GenieSkeleton height={30} sx={{ mt: 1 }} />
      <GenieSkeleton height={36.5} sx={{ mt: 2 }} />
    </Box>
  );
}

export default ProductTileLoad;
